<!-- <div class="row p-x-20 p-t-16 p-b-0">
  <div class="d-sm-none col-lg-2 ">
    <mat-card class="mat-mdc-card mdc-card cardWithShadow theme-card" style="height: 95vh;">
      <mat-card-content class="p-x-10">
        <a class="logolight"> <img src="./assets/images/logos/logo-light.svg" class="align-middle m-2 p-0" width="100%" alt="logo" /> </a>
        <div class="p-15" style="height: 78vh;">
          <div class="mat-mdc-subheader mdc-list-group__subheader nav-caption m-t-24"> Charirty Accounts Software </div>
          <div class="d-flex align-items-center m-t-24 brandbglight p-15 border-radius10">
            <i-tabler name="heart-handshake" class="icon-25 "></i-tabler> <span class="m-l-10 f-s-20">Charities</span> </div>
        </div>
        <div align="center">
          <button mat-flat-button class="brandbglight">
            <div class="d-flex align-items-center">
              <i-tabler class="icon-18" name="plus"></i-tabler> Add Charity </div>
          </button>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="col-sm-12 col-lg-10">
    <div class="container align-items-center text-center p-x-50">
      <div class="row m-t-24">
        <div class="col-12 ">
          <button mat-fab style="width: 80px;height: 80px;border-radius: 50%;" class="brandbglight">
            <i-tabler name="building-skyscraper" class="icon-50 " style="line-height: 70px !important"></i-tabler>
          </button>
          <h2 class="f-s-45 m-0 f-w-700 m-y-24">
              Welcome to <span class="brand ">Charity Accounts</span>
          </h2> </div>

      </div>

              <div class="row p-x-15">

          <mat-card class="mat-mdc-card mdc-card cardWithShadow theme-card p-15 col-12">
            <mat-card-content>
              <h2 class="f-s-20 f-w-800">Get Started</h2>
              <p class="f-s-15 f-w-400 ">To begin using Charity Accounts, you'll need to add your first charity. Let's set up your charity information
                <br/> and financial period details.</p>
              <button mat-fab extended class="brandbg">
                <div class="d-flex align-items-center"> <span class="f-s-16"> Add Your First Charity</span>
                  <i-tabler class="icon-20 m-l-10 " name="arrow-right"></i-tabler>
                </div>
              </button>
            </mat-card-content>
          </mat-card>

            </div>
        <div class="row ">
          <div class="col-sm-12 col-lg-4">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow theme-card p-15">
              <mat-card-content>
                <button mat-fab class="m-b-15" style="line-height: 25px;">
                  <h2 class="f-s-20 f-w-600 ">1</h2> </button>
                <h2 class="f-s-18 f-w-600">Select Charity Type</h2>
                <p class="f-s-15 f-w-400 ">Choose your organisation's structure: CIO, Incorporated, or Unincorporated.</p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-sm-12 col-lg-4">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow theme-card p-15">
              <mat-card-content>
                <button mat-fab class="m-b-15" style="line-height: 25px;">
                  <h2 class="f-s-20 f-w-600 ">2</h2> </button>
                <h2 class="f-s-18 f-w-600">Enter Charity Details</h2>
                <p class="f-s-15 f-w-400 ">Search for your charity or enter details manually for registration.

                </p>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="col-sm-12 col-lg-4">
            <mat-card class="mat-mdc-card mdc-card cardWithShadow theme-card p-15">
              <mat-card-content>
                <button mat-fab class="m-b-15" style="line-height: 25px;">
                  <h2 class="f-s-20 f-w-600 ">3</h2> </button>
                <h2 class="f-s-18 f-w-600">Set Financial Period</h2>
                <p class="f-s-15 f-w-400 ">Configure your accounting period and choose your accounting method.</p>
              </mat-card-content>
            </mat-card>
          </div>
        </div>

              <div class="row p-x-15">
          <div class="text-left andicabg-100 bottom m-t-16 p-24 col-12" style="border-radius: 15px;">
            <div class="align-items-center ">
              <div class="d-flex align-items-center gap-8 brand">
                <i-tabler name="help" class="icon-20  "></i-tabler> <span class=" f-w-700 "> Need Help?</span> </div>
              <p class="f-s-16 m-0 p-x-24 brand2">This software will guide you through the process of producing compliant accounts for your UK charity, with support for different charity types and accounting methods.</p>
            </div>
          </div>
        </div>
    </div>

  </div>
</div> -->



<!--<mat-card class="cardWithShadow m-t-10">
  <mat-card-content class="p-0">-->
    <div class="container align-items-center text-center p-x-50">
      <div class="row m-t-24">
        <div class="col-12 ">
          <button mat-fab style="width: 80px;height: 80px;border-radius: 50%;" class="brandbglight">
            <i-tabler name="building-skyscraper" class="icon-50 " style="line-height: 70px !important"></i-tabler>
          </button>
          <h2 class="f-s-45 m-0 f-w-700 m-y-24" style="font-size: 28px;">
            <!--Welcome to <span class="brand" style="color: #316f8e !important;">Charity Accounts</span>-->
            Welcome to <span class="brand" style="color: #107279 !important;">Charity Accounts</span>
          </h2>
        </div>

      </div>

      <div class="row p-x-15">

        <mat-card class="mat-mdc-card mdc-card cardWithShadow theme-card p-15 col-12" style="border: 1px solid #316f8eb3 !important; background: #fff; box-shadow: -2px 16px 22px -5px #a7a7a7bf !important ">
          <mat-card-content>
            <h2 class="f-s-20 f-w-800">Get Started</h2>
            <p class="f-s-15 f-w-400 ">
              To begin using Charity Accounts, you'll need to add your first charity.<br /> Let's set up your charity information
               and financial period details.
            </p>
            <button mat-fab extended class="brandbg" (click)="addCharity()" style="height: 44px; border-radius: 10px;">
              <div class="d-flex align-items-center">
                <span class="f-s-16"> Add Your First Charity</span>
                <i-tabler class="icon-20 m-l-10 " name="arrow-right"></i-tabler>
              </div>
            </button>
          </mat-card-content>
        </mat-card>

      </div>
      <div class="row m-t-16">
        <div class="col-sm-12 col-lg-4">
          <mat-card class="mat-mdc-card mdc-card cardWithShadow b-0 p-15" style="background: #fff;">
            <mat-card-content>
              <button mat-fab class="m-b-15 brandbglight" style="line-height: 25px;">
                <h2 class="f-s-20 f-w-600 ">1</h2>
              </button>
              <h2 class="f-s-18 f-w-600">Select Charity Type</h2>
              <p class="f-s-15 f-w-400 ">Choose your organisation's structure: CIO, Incorporated, or Unincorporated.</p>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-sm-12 col-lg-4">
          <mat-card class="mat-mdc-card mdc-card cardWithShadow b-0 p-15" style="background: #fff;">
            <mat-card-content>
              <button mat-fab class="m-b-15 brandbglight" style="line-height: 25px;">
                <h2 class="f-s-20 f-w-600 ">2</h2>
              </button>
              <h2 class="f-s-18 f-w-600">Enter Charity Details</h2>
              <p class="f-s-15 f-w-400 ">
                Search for your charity or enter details manually for registration.

              </p>
            </mat-card-content>
          </mat-card>
        </div>
        <div class="col-sm-12 col-lg-4">
          <mat-card class="mat-mdc-card mdc-card cardWithShadow b-0 p-15" style="background: #fff;">
            <mat-card-content>
              <button mat-fab class="m-b-15 brandbglight" style="line-height: 25px;">
                <h2 class="f-s-20 f-w-600 ">3</h2>
              </button>
              <h2 class="f-s-18 f-w-600">Set Financial Period</h2>
              <p class="f-s-15 f-w-400 ">Configure your accounting period and choose your accounting method.</p>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

    </div>
  <!--</mat-card-content>
</mat-card>-->
